import { useState } from "react";
import Homebutton from "../Homebutton";

import {ISRAS} from '../data/isra'
import IsraCard from "../components/IsraCard";

function Israpunt() {
  const [isra, setIsra] = useState(ISRAS)
  return (
    <div className='container'>
      <div className='container-box'>
        <h1 className='text-center'>Isra punten</h1>
        <h2 className='text-center'>Welke isra punten zijn er?</h2>
        <p>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Accusantium
          ea autem aspernatur porro aperiam consequuntur similique repellat
          veritatis a qui nihil maxime aliquid adipisci repellendus eum,
          perspiciatis molestiae totam, omnis rem commodi rerum facere in?
        </p>
        
        {isra.map((item) => {
          return (
            <IsraCard key={item.key} item={item} />
          )
        })}

        <Homebutton />
      </div>
    </div>
  );
}

export default Israpunt;
